document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (event.target.closest('.geo-modal .close-modal')) {
      event.preventDefault();

      const closeButton = event.target.closest('.close-modal');
      const modal = closeButton.closest('.geo-modal');

      // Vanilla JS fadeOut equivalent
      modal.style.transition = 'opacity 200ms ease-in-out';
      modal.style.opacity = '0';
      setTimeout(() => {
        modal.style.display = 'none';
        modal.style.opacity = '1'; // Reset for next time
      }, 200);

      if (modal.getAttribute('id') === 'confirm-locale-modal') {
        if (closeButton.classList.contains('dont-ask-again')) {
          window.localStorage.geo_dont_ask = true;
        } else {
          window.sessionStorage.geo_redirect_dismissed = true;
        }

        var store = stores[window.localStorage.country];
        if (!store) {
          store = INT;
        }

        if (currentStore != store) {
          setTimeout(function () {
            showGeoNotification(store);
          }, 2000);
        }
      }

      return false;
    }
  });

  /**
   * Helper function to detect if you're
   * in a Skincare section of the site
   *
   * @returns boolean
   */
  window.isSkincare = function () {
    return document.body.classList.contains('skincare');
  };
});

// Global Scope Vars
var currentStore = null;
var EU = {
  hosts: ['eu.balibodyco.com'],
  protocol: 'https:',
  ownership: 'Europe',
  multiOwnership: 'Europe',
  multiPlural: 'Europe',
  plural: 'Europe',
  storeCode: 'EU',
};
var UK = {
  hosts: ['uk.balibodyco.com'],
  protocol: 'https:',
  ownership: 'UK',
  multiOwnership: 'UK',
  multiPlural: 'UK/International',
  plural: 'the UK',
  storeCode: 'UK',
};
var INT = {
  hosts: ['int.balibodyco.com'],
  protocol: 'https:',
  ownership: 'International',
  multiOwnership: 'International',
  multiPlural: 'International',
  plural: 'ROW',
  storeCode: 'INT',
};
var AU = {
  hosts: ['au.balibodyco.com', 'raak-bali-body.myshopify.com', 'localhost:3000'],
  protocol: 'https:',
  ownership: 'Australia',
  multiOwnership: 'Australia / N.Z',
  multiPlural: 'Australia / N.Z',
  plural: 'Australia / N.Z',
  storeCode: 'AU',
};
var stores = {
  US: {
    hosts: ['us.balibodyco.com'],
    protocol: 'https:',
    ownership: 'USA',
    multiOwnership: 'the USA',
    multiPlural: 'USA',
    plural: 'the USA',
    prefix: 'the ',
    storeCode: 'US',
  },
  CA: {
    hosts: ['ca.balibodyco.com'],
    protocol: 'https:',
    ownership: 'Canada',
    multiOwnership: 'Canada',
    multiPlural: 'Canada',
    plural: 'Canada',
    storeCode: 'CA',
  },
  AU: AU,
  NZ: AU,
  IE: UK,
  GB: UK,
  AT: EU,
  BE: EU,
  BG: EU,
  HR: EU,
  CY: EU,
  CZ: EU,
  DK: EU,
  EE: EU,
  FI: EU,
  FR: EU,
  DE: EU,
  GR: EU,
  HU: EU,
  IT: EU,
  LV: EU,
  LT: EU,
  LU: EU,
  MT: EU,
  NL: EU,
  AN: EU,
  PL: EU,
  PT: EU,
  RO: EU,
  SK: EU,
  SI: EU,
  ES: EU,
  SE: EU,
  CH: EU,

  INT: INT,
  EU: EU,
  UK: UK,
  RU: EU,
  IL: UK,
};

document.addEventListener('DOMContentLoaded', function () {
  /**
   * Regionalisation
   *
   * Show region switching modal if the user's location does not match
   * the current site region.
   */

  /**
   * If the user agent is a known bot or we're in the theme customiser,
   * return without doing anything. We don't want to show the regionalisation
   * modal to these user agents.
   */
  const isRobot = function () {
    const robotList =
      '(360spider|a6-indexer|aboundex|acoonbot|addthis|adidxbot|admantx|adsbot-google|adsbot-google-mobile|advbot|ahrefsbot|aihitbot|aisearchbot|antibot|apis-google|applebot|arabot|archive.org_bot|backlinkcrawler|baiduspider|bibnum.bnf|biglotron|bingbot|binlar|blekkobot|blexbot|bnf.fr_bot|brainobot|bubing|buzzbot|careerbot|cc metadata scaper|ccbot|changedetection|chrome-lighthouse|citeseerxbot|coccoc|commons-httpclient|content crawler spider|convera|crawler4j|crystalsemanticsbot|curl|cxensebot|cyberpatrol|discobot|domain re-animator bot|domaincrawler|dotbot|drupact|duckduckbot|duplexweb-google|ec2linkfinder|edisterbot|elisabot|europarchive.org|exabot|ezooms|facebookexternalhit|facebot|fast enterprise crawler|fast-webcrawler|feedfetcher-google|findlink|findthatfile|findxbot|fluffy|fr-crawler|g00g1e.net|gigablast|gingercrawler|gnam gnam spider|google favicon|google-read-aloud|googlebot|googlebot-image|googlebot-mobile|googlebot-news|googlebot-video|googleweblight|grapeshotcrawler|grub.org|gslfbot|heritrix|httpunit|httrack|ia_archiver|ichiro|integromedb|intelium_bot|interfaxscanbot|ioi|ip-web-crawler.com|ips-agent|it2media-domain-crawler|java|jyxobot|lb-spider|libwww|linguee bot|linkdex|lipperhey|lipperhey seo service|livelapbot|lssbot|lssrocketcrawler|ltx71|mail.ru_bot|mediapartners-google|megaindex|memorybot|mj12bot|mlbot|msnbot|msrbot|nerdbynature.bot|nerdybot|netresearchserver|ngbot|niki-bot|nutch|openindexspider|orangebot|page2rss|panscient|phpcrawl|postrank|proximic|psbot|purebot|python-urllib|qwantify|retrevopageanalyzer|rogerbot|scribdbot|seekbot|semanticscholarbot|semrushbot|seokicks-robot|seznambot|simplecrawler|sistrix crawler|sitebot|siteexplorer.info|slurp|smtbot|sogou|spbot|speedy|summify|tagoobot|teoma|toplistbot|turnitinbot|tweetmemebot|twengabot|twitterbot|urlappendbot|usinenouvellecrawler|voilabot|voyager|wbsearchbot|web-archive-net.com.bot|webcompanycrawler|webcrawler|webmon|wesee:search|wget|wocbot|woriobot|wotbox|xovibot|y!j-asr|yacybot|yandexbot|yanga|yeti|yoozbot)';
    const regex = new RegExp(robotList, 'i');
    const userAgent = navigator.userAgent;
    return regex.test(userAgent) ? true : false;
  };
  if (isRobot() || window.Shopify.designMode) {
    return;
  }

  // Don't perform this code if the user has already dismissed the modal this session.
  var confirmModal = document.getElementById('confirm-locale-modal');
  var selectModal = document.getElementById('select-locale-modal');
  var dynamic = confirmModal ? confirmModal.querySelector('.dynamic') : null;
  var source = dynamic ? dynamic.innerHTML : '';

  var notification = document.querySelector('.geo-notification');
  var notificationText = notification ? notification.querySelector('.dynamic') : null;
  var notificationTextSource = notificationText ? notificationText.innerHTML : '';

  for (var key in stores) {
    if (stores.hasOwnProperty(key)) {
      if (~stores[key].hosts.indexOf(window.location.host)) {
        currentStore = stores[key];
        break;
      }
    }
  }

  if (!(window.sessionStorage.geo_redirect_dismissed || window.localStorage.geo_dont_ask)) {
    geoip2.country(
      function (response) {
        var store = stores[response.country.iso_code];

        if (!store) {
          // Force countries on the european continent to go to the EU store
          if (response.continent.code === 'EU') {
            store = EU;
          } else {
            store = INT;
          }
        }

        window.localStorage.country = response.country.iso_code;

        if (~store.hosts.indexOf(window.location.host)) {
          // console.info('Looks like we\'re on the correct site.');
        } else {
          // console.info('Looks like we\'re on the incorrect site.');
          showGEOModal(store);
          document.querySelector('#modalTriggeredManually').style.display = 'none';
          document.querySelector('#modalTriggeredAuto').style.display = 'block';
        }
      },
      function () {
        // Error callback - do nothing
      }
    );
  }

  /**
   * Show Geolocation Selection Modal
   *
   * @param {*} store
   */
  function showGEOModal(store) {
    let current = null;

    for (var key in stores) {
      if (stores.hasOwnProperty(key)) {
        if (~stores[key].hosts.indexOf(window.location.host)) {
          current = stores[key];
          break;
        }
      }
    }

    let templateDataStructure = {
      current: current,
      ownership: store.ownership || '',
      prefix: store.prefix || '',
      multiPlural: store.multiPlural || '',
      plural: store.plural || '',
      domain: store.hosts[0], // The first host should always be the correct one.
      link_domain: store.protocol + '//' + store.hosts[0],
    };

    // Update redirect link to Skincare specific link
    if (window.isSkincare()) {
      templateDataStructure.link_domain = `${store.protocol}//${store.hosts[0]}/pages/skincare-homepage`;
    }

    var dynamicHTML = source;
    dynamicHTML = dynamicHTML.replaceAll('{{multiPlural}}', templateDataStructure.multiPlural);
    dynamicHTML = dynamicHTML.replaceAll('{{ link_domain }}', templateDataStructure.link_domain);
    dynamicHTML = dynamicHTML.replaceAll('{{prefix}}', templateDataStructure.prefix);
    dynamicHTML = dynamicHTML.replaceAll('{{current.plural}}', templateDataStructure.current.plural);
    dynamicHTML = dynamicHTML.replaceAll('{{current.prefix}}', templateDataStructure.prefix);
    dynamicHTML = dynamicHTML.replaceAll('{{current.multiPlural}}', templateDataStructure.current.multiPlural);

    //let compiled_html = template(templateDataStructure);
    // Replace the dynamic part of the modal with the compiled HTML.
    if (dynamic) {
      dynamic.innerHTML = dynamicHTML;
    }

    const modalTriggeredManually = document.querySelector('#modalTriggeredManually');
    const modalTriggeredAuto = document.querySelector('#modalTriggeredAuto');

    if (modalTriggeredManually) modalTriggeredManually.style.display = 'block';
    if (modalTriggeredAuto) modalTriggeredAuto.style.display = 'none';

    // Vanilla JS fadeIn equivalent
    if (confirmModal) {
      confirmModal.style.display = 'block';
      confirmModal.style.opacity = '0';
      confirmModal.style.transition = 'opacity 200ms ease-in-out';
      setTimeout(() => {
        confirmModal.style.opacity = '1';
      }, 10);
    }
  }

  function showGeoNotification(store) {
    var notification_html = notificationTextSource
      .replaceAll('{{multiPlural}}', store.multiPlural || '')
      .replaceAll('{{link_domain}}', store.protocol + '//' + store.hosts[0] || 0);

    if (notificationText) {
      notificationText.innerHTML = notification_html;
    }

    if (notification) {
      notification.classList.add('active');
    }
  }

  // Event delegation for store selector links
  document.addEventListener('click', function (event) {
    // Handle store selector link clicks
    if (event.target.matches('[href="#store-selector"]')) {
      event.preventDefault();

      // Vanilla JS fadeOut/fadeIn
      if (confirmModal) {
        confirmModal.style.transition = 'opacity 200ms ease-in-out';
        confirmModal.style.opacity = '0';
        setTimeout(() => {
          confirmModal.style.display = 'none';
          confirmModal.style.opacity = '1'; // Reset for next time
        }, 200);
      }

      if (selectModal) {
        selectModal.style.display = 'block';
        selectModal.style.opacity = '0';
        selectModal.style.transition = 'opacity 200ms ease-in-out';
        setTimeout(() => {
          selectModal.style.opacity = '1';
        }, 10);
      }

      return false;
    }

    // Handle data-store-selector clicks
    if (event.target.hasAttribute('data-store-selector')) {
      event.preventDefault();

      if (selectModal) {
        selectModal.style.transition = 'opacity 200ms ease-in-out';
        selectModal.style.opacity = '0';
        setTimeout(() => {
          selectModal.style.display = 'none';
          selectModal.style.opacity = '1'; // Reset for next time
        }, 200);
      }

      let code = event.target.getAttribute('data-store-selector');
      let store = stores[code];

      if (store) {
        showGEOModal(store);
      }

      return false;
    }
  });

  // Handle duplicate close modal events (this appears to be duplicated in the original)
  document.addEventListener('click', function (event) {
    if (event.target.closest('.geo-modal .close-modal')) {
      event.preventDefault();

      const closeButton = event.target.closest('.close-modal');
      const modal = closeButton.closest('.geo-modal');

      // Vanilla JS fadeOut equivalent
      modal.style.transition = 'opacity 200ms ease-in-out';
      modal.style.opacity = '0';
      setTimeout(() => {
        modal.style.display = 'none';
        modal.style.opacity = '1'; // Reset for next time
      }, 200);

      if (modal.getAttribute('id') === 'confirm-locale-modal') {
        if (closeButton.classList.contains('dont-ask-again')) {
          window.localStorage.geo_dont_ask = true;
        } else {
          window.sessionStorage.geo_redirect_dismissed = true;
        }

        var store = stores[window.localStorage.country];
        if (!store) {
          store = INT;
        }

        if (currentStore != store) {
          setTimeout(function () {
            showGeoNotification(store);
          }, 2000);
        }
      }

      return false;
    }
  });

  // Handle close notification clicks
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('close-notification')) {
      if (notification) {
        notification.classList.remove('active');
      }
    }
  });
});
